import { useSession } from '@/entities/session/hooks/use-session';
import { SyncIndicator } from '@/features/sync-status/components/sync-indicator';
import { APP_VERSION } from '@/shared/config/app-version';
import { useTranslation } from '@/shared/i18n/use-translation';
import { cn } from '@/shared/lib/cn';

type ShellFooterProps = {
  readonly className?: string;
};

/** The sync state and when it last synced on the left; the app version and the server on the right. */
export function ShellFooter({ className }: ShellFooterProps) {
  const { t } = useTranslation();
  const session = useSession();
  return (
    <footer className={cn('flex h-9 shrink-0 items-center justify-between gap-4 px-2 text-xs', className)}>
      <SyncIndicator showLastSync className="text-xs" />
      <span className="truncate text-muted-foreground tabular-nums">
        {session
          ? t('Version {version} · server {server}', {
              version: APP_VERSION,
              server: session.server_id.slice(0, 8),
            })
          : t('Version {version}', { version: APP_VERSION })}
      </span>
    </footer>
  );
}
